<template>
    <div>
        <key-information 
            :tableName="tableName"
            :columnData="columnData"
            :tableHeader="tableHeader"
            :tableHeaderData="tableHeaderData"
        >
        </key-information>
    </div>
</template>

<script>
import Vue from 'vue';
import KeyInformation from '@/components/pages/project/percent_progress/common/tables/key_information.vue';

export default {
    name: 'key_information_bw_welding',
    components: {
        KeyInformation,
    },
    data() {
        return {
            tableName: 'progress_bw_welding_key',
            columnData: [
                {
                    label: Vue.i18n.translate('table.prefabrication_days_remainting_until_end'),
                    field: 'prefabrication_days_remainting_until_end',
                },
                {
                    label: Vue.i18n.translate('table.erection_days_remainting_until_end'),
                    field: 'erection_days_remainting_until_end',
                },
                {
                    label: Vue.i18n.translate('table.prefabrication_average_inch_per_day_left'),
                    field: 'prefabrication_average_inch_per_day_left_total_estimated',
                },
                {
                    label: Vue.i18n.translate('table.erection_average_inch_per_day_left'),
                    field: 'erection_average_inch_per_day_left_total_estimated',
                },
                {
                    label: Vue.i18n.translate('table.prefabrication_average_inch_per_day_left'),
                    field: 'prefabrication_average_inch_per_day_left_current_available',
                },
                {
                    label: Vue.i18n.translate('table.erection_average_inch_per_day_left'),
                    field: 'erection_average_inch_per_day_left_current_available',
                },
            ],
            //Header
            tableHeader: true,
            tableHeaderData: {
                start: 1,
                values: [
                    {
                        text: 'table.from_total_estimated',
                        colspan: 2,
                        class: 'text-center',
                    },
                    {
                        text: 'table.from_current_available',
                        colspan: 2,
                        class: 'text-center',
                    },
                ]
            }
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/pages/project/percent_progress/bw_welding/key_information/key_information_bw_welding.vue